// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelViewLoading-HeaderTitle_cls1__JwO6q","cls2":"PaymentChannelViewLoading-HeaderTitle_cls2__gNMYh PaymentChannelViewLoading-HeaderTitle_cls1__JwO6q"};